export const messages = {
    internetStore: 'ÙØ±ÙØ´Ú¯Ø§Ù Ø§ÛÙØªØ±ÙØªÛ',
    justByNow: 'ÙÙÛÙ Ø§ÙØ§Ù Ø®Ø±ÛØ¯ Ú©Ù!',
    allKindsDetergentProducts: 'Ø§ÙÙØ§Ø¹ ÙØ­ØµÙÙØ§Øª Ø®ÙØ±Ø§Ú©Û Ù Ø´ÙÛÙØ¯Ù',
    lowerPrice: 'Ø¨Ø§ Ø¨ÙØ§Û Ú©ÙØªØ±Ø ÙØ³ØªÙÛÙ Ù Ø¨Ø¯ÙÙ ÙØ§Ø³Ø·Ù Ø§Ø² Ú©Ø§Ø±Ø®Ø§ÙÙ',
    famusBrand: 'Ø¨Ø±ÙØ¯ÙØ§Û ÙØ§Ù Ø¢Ø´ÙØ§',
    likeOnline: 'Ø¨ØµÙØ±Øª Ø¢ÙÙØ§ÛÙ',
    instagram: 'Ø§ÛÙØ³ØªØ§Ú¯Ø±Ø§Ù',
    instagramLink: 'https://www.instagram.com/SarfeMarket/',
    googlePlayLink: "https://play.google.com/store/apps/details?id=com.apptech.topchino_customer",
    cafeBazaarLink: 'https://cafebazaar.ir/app/com.apptech.topchino_customer',
    ok: 'Ø¨Ø§Ø´Ù',
    error: 'Ø®Ø·Ø§',
    successPayment_1: 'Ù¾Ø±Ø¯Ø§Ø®Øª ÙÙÙÙ',
    errorPayment: 'Ù¾Ø±Ø¯Ø§Ø®Øª ÙØ§ÙÙÙÙ',
    warning: 'ÙØ´Ø¯Ø§Ø±',
    success: 'ÙÙÙÙ',
    farvardin: 'ÙØ±ÙØ±Ø¯ÛÙ',
    forExample: 'Ø¨Ø±Ø§Û ÙØ«Ø§Ù 09123456789',
    ordibehesht: 'Ø§Ø±Ø¯ÛØ¨ÙØ´Øª',
    khordad: 'Ø®Ø±Ø¯Ø§Ø¯',
    tir: 'ØªÛØ±',
    mordad: 'ÙØ±Ø¯Ø§Ø¯',
    shahrivar: 'Ø´ÙØ±ÛÙØ±',
    mehr: 'ÙÙØ±',
    aban: 'Ø¢Ø¨Ø§Ù',
    azar: 'Ø¢Ø°Ø±',
    dey: 'Ø¯Û',
    bahman: 'Ø¨ÙÙÙ',
    esfand: 'Ø§Ø³ÙÙØ¯',
    user: 'Ú©Ø§Ø±Ø¨Ø±',
    successAddOrder: "Ø³ÙØ§Ø±Ø´ Ø´ÙØ§ Ø¨Ø§ ÙÙÙÙÛØª Ø¯Ø± Ø³ÛØ³ØªÙ Ø«Ø¨Øª Ú¯Ø±Ø¯ÛØ¯",
    orderId: " Ú©Ø¯ Ù¾ÛÚ¯ÛØ±Û ",
    basketChangeMessage: "Ø³Ø¨Ø¯ Ø®Ø±ÛØ¯ Ø´ÙØ§ ØªØºÛÛØ± ÛØ§ÙØªÙ Ø§Ø³Øª ÙØ·ÙØ§ ÙØ¬Ø¯Ø¯Ø§ Ø¨Ù Ø³Ø¨Ø¯ Ø®ÙØ¯ Ø¨Ø±Ú¯Ø±Ø¯ÛØ¯ Ù Ù¾Ø³ Ø§Ø² ÙØ´Ø§ÙØ¯Ù ØªØºÛÛØ±Ø§Øª Ø§ÙØ¯Ø§Ù Ø¨Ù Ø«Ø¨Øª Ø³ÙØ§Ø±Ø´ ÙÙØ§ÛÛØ¯",
    basketChange: "ØªØºÛÛØ± Ø¯Ø± Ø³Ø¨Ø¯ Ø®Ø±ÛØ¯",
    basketChangeTitle: "Ø³Ø¨Ø¯ Ø®Ø±ÛØ¯ Ø´ÙØ§ ØªØºÛÛØ± ÛØ§ÙØªÙ Ø§Ø³Øª",
    userInviteYou: 'Ø´ÙØ§ Ø±Ø§ Ø¨Ù Ø¬ÙØ¹ ÙØ§ Ø¯Ø¹ÙØª Ú©Ø±Ø¯Ù Ø§Ø³ØªØ Ø¨Ø±Ø§Û Ù¾ÛÙØ³ØªÙ Ø¨Ù Ø®Ø§ÙÙØ§Ø¯Ù Ø¨Ø²Ø±Ú¯ ØµØ±ÙÙ ÙØ§Ø±Ú©Øª ÙØ·ÙØ§ Ø´ÙØ§Ø±Ù ØªÙØ§Ø³ Ø®ÙØ¯ Ø±Ø§ ÙØ§Ø±Ø¯ Ú©ÙÛØ¯',
    userAccount: 'Ø­Ø³Ø§Ø¨ Ú©Ø§Ø±Ø¨Ø±Û',
    editTelephone: 'Ø§ØµÙØ§Ø­ Ø´ÙØ§Ø±Ù',
    myOrders: 'Ø³ÙØ§Ø±Ø´Ø§Øª ÙÙ',
    aboutUs: 'Ø¯Ø±Ø¨Ø§Ø±Ù ÙØ§',
    myRewards: 'Ø¬Ø§ÛØ²Ù ÙØ§Û ÙÙ',
    basket: 'Ø³Ø¨Ø¯ Ø®Ø±ÛØ¯',
    return: 'Ø¨Ø§Ø²Ú¯Ø´Øª',
    search: 'Ø¬Ø³ØªØ¬Ù',
    searchBrand: 'Ø¬Ø³ØªØ¬Ù Ø¨Ø±ÙØ¯',
    yourLocation: 'ÙÙÙØ¹ÛØª Ø´ÙØ§',
    driverLocation: 'ÙÙÙØ¹ÛØª Ù¾ÛÚ© Ø´ÙØ§',
    searchPlace: 'ÙØ§Ù ÙÙØ·ÙÙØ ÙØ­ÙÙØ Ø®ÛØ§Ø¨Ø§Ù Ù ...',
    inCategory: " Ø¯Ø± Ø¯Ø³ØªÙ ",
    showAllSearchFor: "ÙÙØ§ÛØ´ ÙÙÙ ÙØªØ§ÛØ¬ Ø¨Ø±Ø§Û ",
    telephone: 'Ø´ÙØ§Ø±Ù ÙÙØ¨Ø§ÛÙ',
    phone: 'ØªÙÙÙ',
    attention: 'ØªÙØ¬Ù',
    messageTitle: 'Ø¹ÙÙØ§Ù Ù¾ÛØ§Ù',
    relatedProducts: 'ÙØ­ØµÙÙØ§Øª ÙØ´Ø§Ø¨Ù',
    otherBuy: 'Ø¯ÛÚ¯Ø±Ø§Ù Ø§ÛÙ Ú©Ø§ÙØ§ÙØ§ Ø±Ø§ ÙÛØ² Ø®Ø±ÛØ¯ Ú©Ø±Ø¯Ù Ø§ÙØ¯',
    messageDescription: 'ÙØªÙ Ù¾ÛØ§Ù',
    yourInviteCode: 'Ú©Ø¯ ÙØ¹Ø±ÙÛ Ø´ÙØ§',
    verifyCode: 'Ú©Ø¯ ÙØ¹Ø§ÙØ³Ø§Ø²Û',
    fullName: 'ÙØ§Ù Ù ÙØ§Ù Ø®Ø§ÙÙØ§Ø¯Ú¯Û',
    email: 'Ù¾Ø³Øª Ø§ÙÚ©ØªØ±ÙÙÛÚ©',
    nationalId: 'Ú©Ø¯ ÙÙÛ',
    birthDate: 'ØªØ§Ø±ÛØ® ØªÙÙØ¯',
    male: 'ÙÙØ±Ø¨Ø§Ù ( ÙØ±Ø¯ )',
    female: 'ÙÙØ±Ø¨Ø§ÙÙ ( Ø²Ù )',
    verifyCodeSendedTo: " Ú©Ø¯ ÙØ¹Ø§ÙØ³Ø§Ø²Û Ù¾ÛØ§ÙÚ© Ø´Ø¯Ù Ø¨Ù Ø´ÙØ§Ø±Ù ",
    entedIt: " Ø±Ø§ ÙØ§Ø±Ø¯ Ú©ÙÛØ¯ ",
    inviteCode: 'Ú©Ø¯ ÙØ¹Ø±Ù (Ø§Ø®ØªÛØ§Ø±Û)',
    home: 'Ø®Ø§ÙÙ',
    sarfeMarketEn: 'SarfeMarket',
    count: 'ØªØ¹Ø¯Ø§Ø¯',
    resend: 'Ø§Ø±Ø³Ø§Ù ÙØ¬Ø¯Ø¯',
    category: 'Ø¯Ø³ØªÙ Ø¨ÙØ¯Û Ú©Ø§ÙØ§ÙØ§',
    connectWithUsAddress: 'Ø¢Ø¯Ø±Ø³ ÙØ§',
    connectWithUs: 'Ø§Ø±ØªØ¨Ø§Ø· Ø¨Ø§ ÙØ§',
    applicationDownload: 'Ø¯Ø§ÙÙÙØ¯ Ø§Ù¾ÙÛÚ©ÛØ´Ù',
    forApplicationDownload: 'Ø¨Ø±Ø§Û Ø¯Ø§ÙÙÙØ¯ Ø§Ù¾ÙÛÚ©ÛØ´Ù ØµØ±ÙÙ ÙØ§Ø±Ú©Øª ÙØ·ÙØ§ Ø¨Ø± Ø±ÙÛ ÙØ§Ø±Ú©Øª Ø¯ÙØ®ÙØ§Ù Ø®ÙØ¯ Ú©ÙÛÚ© Ú©ÙÛØ¯',
    connectWithUsPhone: 'ØªÙÙÙ ØªÙØ§Ø³ Ø¨Ø§ ÙØ§',
    connectWithUsEmail: 'Ø§Ø±ØªØ¨Ø§Ø· Ø§Ø² Ø·Ø±ÛÙ Ù¾Ø³Øª Ø§ÙÚ©ØªØ±ÙÙÛÚ©',
    seggestionDescription: 'ÙØ·ÙØ§ Ø§ÙØªÙØ§Ø¯Ø§Øª Ù Ù¾ÛØ´ÙÙØ§Ø¯Ø§Øª Ø®ÙØ¯ Ø±Ø§ Ø¬ÙØª Ø¨ÙØªØ± Ø´Ø¯Ù ØµØ±ÙÙ ÙØ§Ø±Ú©Øª Ø¨Ø§ ÙØ§ Ø¯Ø±ÙÛØ§Ù Ø¨Ú¯Ø°Ø§Ø±ÛØ¯',
    orders: 'Ø³ÙØ§Ø±Ø´Ø§Øª',
    orderNumber: 'Ø´ÙØ§Ø±Ù Ø³ÙØ§Ø±Ø´',
    ticketNumber:"Ú©Ø¯ Ù¾ÛÚ¯ÛØ±Û",
    customerClub: 'Ø¨Ø§Ø´Ú¯Ø§Ù ÙØ´ØªØ±ÛØ§Ù',
    download: 'Ø¯Ø§ÙÙÙØ¯',
    seeAll: 'ÙØ´Ø§ÙØ¯Ù ÙÙÙ',
    returnToMainPage: 'Ø¨Ø§Ø²Ú¯Ø´Øª Ø¨Ù ØµÙØ­Ù Ø§ØµÙÛ',
    enter: 'ÙØ±ÙØ¯',
    city: 'Ø´ÙØ±',
    editAddress: 'ÙÛØ±Ø§ÛØ´ Ø¢Ø¯Ø±Ø³',
    submitFilterPrice: 'Ø§Ø¹ÙØ§Ù ÙØ­Ø¯ÙØ¯Ù ÙÛÙØª',
    use: 'Ø§Ø¹ÙØ§Ù',
    deleteFromCart: 'Ø­Ø°Ù Ú©Ø§ÙØ§',
    deleteAddress: 'Ø­Ø°Ù Ø¢Ø¯Ø±Ø³',
    deleteNotification: 'Ø­Ø°Ù Ø§Ø¹ÙØ§Ù',
    sureCancelOrder: 'Ø¢ÛØ§ Ø§Ø·ÙÛÙØ§Ù Ø¯Ø§Ø±ÛØ¯ ÙÛ Ø®ÙØ§ÙÛØ¯ Ø³ÙØ§Ø±Ø´ Ø®ÙØ¯ Ø±Ø§ Ø§Ø¨Ø·Ø§Ù Ú©ÙÛØ¯Ø',
    sureEditOrder: 'Ø¢ÛØ§ Ø§Ø·ÙÛÙØ§Ù Ø¯Ø§Ø±ÛØ¯ ÙÛ Ø®ÙØ§ÙÛØ¯ Ø³ÙØ§Ø±Ø´ Ø®ÙØ¯ Ø±Ø§ ÙÛØ±Ø§ÛØ´ Ú©ÙÛØ¯Ø',
    sureCompleteOrder: 'Ø¢ÛØ§ Ø§Ø·ÙÛÙØ§Ù Ø¯Ø§Ø±ÛØ¯ ÙÛ Ø®ÙØ§ÙÛØ¯ Ø³ÙØ§Ø±Ø´ Ø®ÙØ¯ Ø±Ø§ ØªÚ©ÙÛÙ Ú©ÙÛØ¯Ø',
    expireDate: 'ØªØ§Ø±ÛØ® Ø§ÙÙØ¶Ø§',
    edit: 'ÙÛØ±Ø§ÛØ´',
    subject: 'ÙÙØ¶ÙØ¹',
    peykLocation: 'ÙØ´Ø§ÙØ¯Ù ÙÙÙØ¹ÛØª ÙÙØ²Ø¹',
    completeOrder: 'ØªÚ©ÙÛÙ Ø³ÙØ§Ø±Ø´',
    editOrder: 'ÙÛØ±Ø§ÛØ´ Ø³ÙØ§Ø±Ø´',
    addToBasket: 'Ø§ÙØ²ÙØ¯Ù Ø¨Ù Ø³Ø¨Ø¯ Ø®Ø±ÛØ¯',
    selectAddress: 'Ø§ÙØªØ®Ø§Ø¨ Ø¢Ø¯Ø±Ø³',
    selectTimeAddress: 'Ø§ÙØªØ®Ø§Ø¨ Ø¢Ø¯Ø±Ø³ Ù Ø²ÙØ§Ù',
    selectDefaultPaymentTypePlease: "ÙØ·ÙØ§ Ø´ÛÙÙ Ù¾Ø±Ø¯Ø§Ø®Øª Ø±Ø§ Ø§ÙØªØ®Ø§Ø¨ Ú©ÙÛØ¯",
    selectDefaultAddressPlease: "ÙØ·ÙØ§ Ø¢Ø¯Ø±Ø³ Ù¾ÛØ´ ÙØ±Ø¶ Ø±Ø§ Ø§ÙØªØ®Ø§Ø¨ Ú©ÙÛØ¯",
    selectDeliverDatePlease: "ÙØ·ÙØ§ Ø±ÙØ² Ù Ø³Ø§Ø¹Øª Ø§Ø±Ø³Ø§Ù Ø³ÙØ§Ø±Ø´ Ø±Ø§ Ø§ÙØªØ®Ø§Ø¨ ÙÙØ§ÛÛØ¯",
    selectDeliverAddress: 'Ø§ÙØªØ®Ø§Ø¨ Ø¢Ø¯Ø±Ø³ ØªØ­ÙÛÙ',
    addressNotFound: 'Ø¢Ø¯Ø±Ø³Û Ø¨Ø±Ø§Û Ø´ÙØ§ ÛØ§ÙØª ÙØ´Ø¯Ø ÙØ·ÙØ§ Ø¢Ø¯Ø±Ø³ ØªØ­ÙÛÙ Ø®ÙØ¯ Ø±Ø§ Ø«Ø¨Øª ÙÙØ§ÛÛØ¯',
    selectDeliverType: 'Ø§ÙØªØ®Ø§Ø¨ Ø²ÙØ§Ù Ø§Ø±Ø³Ø§Ù',
    selectPaymentType: 'Ø§ÙØªØ®Ø§Ø¨ Ø±ÙØ´ Ù¾Ø±Ø¯Ø§Ø®Øª',
    finalRegister: 'ÙÙØ§ÛÛ Ø³Ø§Ø²Û',
    orderRegister: 'Ø«Ø¨Øª Ø³ÙØ§Ø±Ø´',
    showOrder: 'ÙØ´Ø§ÙØ¯Ù Ø³ÙØ§Ø±Ø´',
    pay: 'Ù¾Ø±Ø¯Ø§Ø®Øª',
    backToSelectDateTime: 'Ø¨Ø§Ø²Ú¯Ø´Øª Ø¨Ù ØµÙØ­Ù Ø§ÙØªØ®Ø§Ø¨ ØªØ§Ø±ÛØ® Ù Ø³Ø§Ø¹Øª',
    changeAddress: 'ØªØºÛÛØ± Ø¢Ø¯Ø±Ø³',
    editReward: 'ÙÛØ±Ø§ÛØ´ Ø¬Ø§ÛØ²Ù',
    clearBasket: 'Ø®Ø§ÙÛ Ú©Ø±Ø¯Ù Ø³Ø¨Ø¯',
    notifyMe: 'ÙÙØ¬ÙØ¯ Ø´Ø¯ Ø®Ø¨Ø±Ù Ú©Ù',
    dontNotifyMe: 'Ø¯ÛÚ¯ ÙØ§Ø²Ù ÙÛØ³Øª Ø®Ø¨Ø±Ù Ú©ÙÛ',
    sendMessage: 'Ø«Ø¨Øª Ù¾Ø§Ø³Ø® Ø¬Ø¯ÛØ¯',
    copy: 'Ú©Ù¾Û ÙÛÙÚ©',
    activate: 'ÙØ¹Ø§ÙØ³Ø§Ø²Û',
    inviteFriends: "Ø¯Ø¹ÙØª Ø§Ø² Ø¯ÙØ³ØªØ§Ù",
    notifications: "Ø§Ø¹ÙØ§ÙØ§Øª",
    invited: "Ø¯Ø¹ÙØª Ø´Ø¯Ù ÙØ§",
    inviteDescription: "Ú©Ø§Ø±Ø¨Ø± Ú¯Ø±Ø§ÙÛ Ø¬ÙØª ÙØ¹Ø±ÙÛ ØµØ±ÙÙ ÙØ§Ø±Ú©Øª Ø¨Ù Ø¯ÙØ³ØªØ§ÙØªØ§Ù ÙØ·ÙØ§ ÙÛÙÚ© Ø²ÛØ± Ø±Ù Ø¨Ø±Ø§Ø´ÙÙ Ø§Ø±Ø³Ø§Ù Ú©ÙÛØ¯",
    trackingCodeCopied: "Ú©Ø¯ Ù¾ÛÚ¯ÛØ±Û Ú©Ù¾Û Ø´Ø¯",
    inviteLinkCopied: "ÙÛÙÚ© ÙØ¹Ø±ÙÛ Ø¨Ù Ø¯ÙØ³ØªØ§Ù Ú©Ù¾Û Ø´Ø¯",
    discountCodeCopied: "Ú©Ø¯ ØªØ®ÙÛÙ Ú©Ù¾Û Ø´Ø¯",
    sarfeBonCopied: "ØµØ±ÙÙ Ø¨Ù Ú©Ù¾Û Ø´Ø¯",
    registered: "Ø«Ø¨Øª ÙØ§Ù Ø´Ø¯Ù ÙØ§",
    logout: "Ø®Ø±ÙØ¬ Ø§Ø² Ø­Ø³Ø§Ø¨ Ú©Ø§Ø±Ø¨Ø±Û",
    login: "ÙØ±ÙØ¯ Ø¨Ù Ø­Ø³Ø§Ø¨ Ú©Ø§Ø±Ø¨Ø±Û",
    sureLogin: "ÙØ±Ø¢ÛÙØ¯ ÙØ±ÙØ¯ Ø´ÙØ§ ØªÚ©ÙÛÙ ÙØ´Ø¯Ù Ø§Ø³ØªØ Ø¨Ù ÙÙØ¸ÙØ± Ø§Ø¯Ø§ÙÙ ÙØ±Ø¢ÛÙØ¯ Ø§Ø¨ØªØ¯Ø§ Ø¨Ø§ÛØ¯ ÙØ§Ø±Ø¯ Ø´ÙÛØ¯Ø Ø¢ÛØ§ ÙØ§ÛÙ ÙØ³ØªÛØ¯Ø",
    sureLogout: "Ø¢ÛØ§ ÙÛ Ø®ÙØ§ÙÛØ¯ Ø§Ø² Ø­Ø³Ø§Ø¨ Ú©Ø§Ø±Ø¨Ø±Û Ø®ÙØ¯ Ø®Ø§Ø±Ø¬ Ø´ÙÛØ¯Ø",
    sureDeleteAddress: "Ø¢ÛØ§ Ø§Ø² Ø­Ø°Ù Ø¢Ø¯Ø±Ø³ Ø§Ø·ÙÛÙØ§Ù Ø¯Ø§Ø±ÛØ¯Ø",
    sureDeleteFromCart: "Ø¢ÛØ§ Ø§Ø² Ø­Ø°Ù Ú©Ø§ÙØ§ Ø§Ø² Ø³Ø¨Ø¯ Ø®Ø±ÛØ¯ Ø§Ø·ÙÛÙØ§Ù Ø¯Ø§Ø±ÛØ¯Ø",
    sureDeleteNotification: "Ø¢ÛØ§ Ø§Ø² Ø­Ø°Ù Ø§Ø¹ÙØ§Ù Ø§Ø·ÙÛÙØ§Ù Ø¯Ø§Ø±ÛØ¯Ø",
    sureClearBasket: "Ø¢ÛØ§ Ø§Ø² Ø®Ø§ÙÛ Ú©Ø±Ø¯Ù Ø³Ø¨Ø¯ Ø®Ø±ÛØ¯ Ø§Ø·ÙÛÙØ§Ù Ø¯Ø§Ø±ÛØ¯Ø",
    myAddress: "Ø¢Ø¯Ø±Ø³ ÙØ§Û ÙÙ",
    addAddress: "Ø§ÙØ²ÙØ¯Ù Ø¢Ø¯Ø±Ø³",
    addIamge: "Ø§ÙØ²ÙØ¯Ù ØªØµÙÛØ±",
    addVoice: "Ø¶Ø¨Ø· Ù¾ÛØ§Ù ØµÙØªÛ",
    addRate: "Ø«Ø¨Øª ÙØ¸Ø±",
    isEmpty: " Ø®Ø§ÙÛ ÙÛ Ø¨Ø§Ø´Ø¯ ",
    list: " ÙÛØ³Øª ",
    addressesListEmpty: "ÙÛØ³Øª Ø¢Ø¯Ø±Ø³ ÙØ§Û Ø´ÙØ§ Ø®Ø§ÙÛ ÙÛ Ø¨Ø§Ø´Ø¯",
    rewardListEmpty: "ÙÛØ³Øª Ø¬Ø§ÛØ²Ù ÙØ§Û Ø´ÙØ§ Ø®Ø§ÙÛ ÙÛ Ø¨Ø§Ø´Ø¯",
    productListEmpty: "ÙÛØ³Øª Ú©Ø§ÙØ§ÙØ§ Ø®Ø§ÙÛ ÙÛ Ø¨Ø§Ø´Ø¯",
    productList: "ÙÛØ³Øª ÙØ­ØµÙÙØ§Øª",
    orderListEmpty: "ÙÛØ³Øª Ø³ÙØ§Ø±Ø´Ø§Øª Ø´ÙØ§ Ø®Ø§ÙÛ ÙÛ Ø¨Ø§Ø´Ø¯",
    ticketListEmpty: "ÙÛØ³Øª ØªÛÚ©Øª ÙØ§Û Ø´ÙØ§ Ø®Ø§ÙÛ ÙÛ Ø¨Ø§Ø´Ø¯",
    notificationListEmpty: "ÙÛØ³Øª Ø§Ø¹ÙØ§ÙØ§Øª Ø´ÙØ§ Ø®Ø§ÙÛ ÙÛ Ø¨Ø§Ø´Ø¯",
    basketIsEmpty: "Ø³Ø¨Ø¯ Ø®Ø±ÛØ¯ Ø´ÙØ§ Ø®Ø§ÙÛ ÙÛ Ø¨Ø§Ø´Ø¯",
    pleaseSelectLocation: "ÙØ·ÙØ§ ÙÙÙØ¹ÛØª ÙÚ©Ø§ÙÛ Ø®ÙØ¯ Ø±Ø§ Ø¨Ø± Ø±ÙÛ ÙÙØ´Ù ØªØ¹ÛÛÙ Ú©ÙÛØ¯",
    addAddressError: "Ø¯Ø± ÙØ±Ø¢ÛÙØ¯ Ø«Ø¨Øª Ø¢Ø¯Ø±Ø³ Ø®Ø·Ø§ÛÛ Ø±Ø® Ø¯Ø§Ø¯Ù Ø§Ø³Øª",
    rateOrderError: "Ø¯Ø± ÙØ±Ø¢ÛÙØ¯ Ø«Ø¨Øª Ø§ÙØªÛØ§Ø² Ø¨Ø±Ø§Û Ø³ÙØ§Ø±Ø´ Ø®Ø·Ø§ÛÛ Ø±Ø® Ø¯Ø§Ø¯Ù Ø§Ø³Øª",
    pleaseFillAllInfo: "Ù¾Ø± Ú©Ø±Ø¯Ù ÙÙÙ Û Ú¯Ø²ÛÙÙ ÙØ§ Ø§ÙØ²Ø§ÙÛ Ø§Ø³Øª",
    cannotDeleteAddress: "Ø¨Ù Ø¯ÙÛÙ Ø¯Ø§Ø´ØªÙ Ø³ÙØ§Ø±Ø´ ÙØ¹Ø§Ù Ø¨Ø§ Ø§ÛÙ Ø¢Ø¯Ø±Ø³Ø Ø§ÙÚ©Ø§Ù ÙÛØ±Ø§ÛØ´ Ù ÛØ§ Ø­Ø°Ù Ø¢Ù ØªØ§ ÙÙØ§ÛÛ Ø´Ø¯Ù Ø³ÙØ§Ø±Ø´ Ø§ÙÚ©Ø§Ù Ù¾Ø°ÛØ± ÙÙÛ Ø¨Ø§Ø´Ø¯",
    toAddNewAddress: " Ø¬ÙØª Ø§ÙØ²ÙØ¯Ù Ø¢Ø¯Ø±Ø³ Ø¬Ø¯ÛØ¯ Ø¨Ø± Ø±ÙÛ Ø¯Ú©ÙÙ ",
    pleaseSelectRate: "ÙØ·ÙØ§ Ø§ÙØªÛØ§Ø² Ø³ÙØ§Ø±Ø´ Ø±Ø§ Ø§ÙØªØ®Ø§Ø¨ Ú©ÙÛØ¯",
    clicked: " Ú©ÙÛÚ© Ú©ÙÛØ¯ ",
    account: "Ø­Ø³Ø§Ø¨ Ú©Ø§Ø±Ø¨Ø±Û",
    dearUser: " Ú©Ø§Ø±Ø¨Ø± Ú¯Ø±Ø§ÙÛ ",
    welcome: " Ø®ÙØ´ Ø¢ÙØ¯ÛØ¯ ",
    priceUnit: " ØªÙÙØ§Ù ",
    percentUnit: " Ø¯Ø±ØµØ¯ ",
    more: "Ø¨ÛØ´ØªØ±",
    seeMore: "ÙØ´Ø§ÙØ¯Ù Ø¨ÛØ´ØªØ±",
    less: "Ú©ÙØªØ±",
    seeLess: "ÙØ´Ø§ÙØ¯Ù Ú©ÙØªØ±",
    validityTo: " Ø§Ø¹ØªØ¨Ø§Ø± ØªØ§ ",
    free: "Ø±Ø§ÛÚ¯Ø§Ù",
    productNotExist: "ÙØªØ§Ø³ÙØ§ÙÙ Ø§ÛÙ Ú©Ø§ÙØ§ Ø¯Ø± Ø§ÙØ¨Ø§Ø± ØµØ±ÙÙ ÙØ§Ø±Ú©Øª ÙÙØ¬ÙØ¯ ÙÙÛ Ø¨Ø§Ø´Ø¯",
    ipgResultError: "Ú©Ø§Ø±Ø¨Ø± Ú¯Ø±Ø§ÙÛØ Ø§Ø·ÙØ§Ø¹Ø§Øª Ù¾Ø±Ø¯Ø§Ø®Øª ÙØ¹ØªØ¨Ø± ÙÙÛ Ø¨Ø§Ø´Ø¯Ø ÙØ·ÙØ§ Ø¨Ù ØµÙØ­Ù Ø§ÙØªØ®Ø§Ø¨ ØªØ§Ø±ÛØ® Ù Ø³Ø§Ø¹Øª Ø¨Ø§Ø²Ú¯Ø±Ø¯ÛØ¯ Ù ÙØ¬Ø¯Ø¯Ø§ ÙØ±Ø§Ø­Ù Ø«Ø¨Øª Ø³ÙØ§Ø±Ø´ Ø±Ø§ Ø§ÙØ¬Ø§Ù Ø¯ÙÛØ¯",
    ipgWalletResultError: "Ú©Ø§Ø±Ø¨Ø± Ú¯Ø±Ø§ÙÛØ Ø§Ø·ÙØ§Ø¹Ø§Øª Ù¾Ø±Ø¯Ø§Ø®Øª ÙØ¹ØªØ¨Ø± ÙÙÛ Ø¨Ø§Ø´Ø¯Ø ÙØ·ÙØ§ Ø¨Ù ØµÙØ­Ù Ú©ÛÙ Ù¾ÙÙ Ø¨Ø§Ø²Ú¯Ø±Ø¯ÛØ¯ Ù ÙØ¬Ø¯Ø¯Ø§ ÙØ±Ø§Ø­Ù Ø±Ø§ Ø§ÙØ¬Ø§Ù Ø¯ÙÛØ¯",
    price: "ÙÛÙØª",
    priceRange: "ÙØ­Ø¯ÙØ¯Ù ÙÛÙØª",
    fee: "ÙØ¨ÙØº",
    value: "ÙÙØ¯Ø§Ø±",
    minValue: "Ø­Ø¯Ø§ÙÙ ÙØ¨ÙØº Ø³ÙØ§Ø±Ø´",
    maxValue: "Ø­Ø¯Ø§Ú©Ø«Ø± ÙØ¨ÙØº Ø³ÙØ§Ø±Ø´",
    totalPrice: "ÙØ¨ÙØº Ú©Ù",
    totalOrderPrice: "ÙØ¨ÙØº Ø³ÙØ§Ø±Ø´",
    totalFactorOrderPrice: "ÙÛÙØª ÙØ§Ú©ØªÙØ±",
    totalOrderPriceNew: "ÙÛÙØª ÙÙØ§ÛÛ",
    products_discount: "ÙÛÙØª ÙØ§Ú©ØªÙØ±",
    paymentPrice: "ÙØ¨ÙØº",
    submit: "ØªØ§ÛÛØ¯",
    cancel: "Ø§ÙØµØ±Ø§Ù",
    cancelOrder: "ÙØºÙ Ø³ÙØ§Ø±Ø´",
    detailOrder: "Ø¬Ø²Ø¦ÛØ§Øª Ø³ÙØ§Ø±Ø´",
    is: "ÙØ³Øª",
    isNot: "ÙÛØ³Øª",
    oldPrice: "ÙÛÙØª ÙØ¯ÛÙ",
    allCategory: " ÙÙÙ Ø¯Ø³ØªÙâØ¨ÙØ¯ÛâÙØ§Û ",
    support: "Ù¾Ø´ØªÛØ¨Ø§ÙÛ",
    onlinePayment: "Ø§ÛÙØªØ±ÙØªÛ",
    cashPayment: "ÙÙØ¯Û",
    posPayment: "Ú©Ø§Ø±Øª Ø®ÙØ§Ù",
    roleAndCondition: "ÙÙØ§ÙÛÙ Ù Ø´Ø±Ø§ÛØ· ",
    sarfeMarket: " ØµØ±ÙÙ ÙØ§Ø±Ú©Øª ",
    sarfeMarketEmail: "info@sarfemarket.ir",
    sarfeMarketInstagram: "Sarfemarket@",
    sarfeMarketAddress: "ØªÙØ±Ø§ÙØ Ø®ÛØ§Ø¨Ø§Ù Ø¢Ø²Ø§Ø¯ÛØ Ø¨ÙÙØ§Ø± Ø§Ø³ØªØ§Ø¯ ÙØ¹ÛÙØ Ù¾ÙØ§Ú© 172",
    criticsAndSuggestion: "Ø¯Ø±Ø®ÙØ§Ø³Øª Ù¾Ø´ØªÛØ¨Ø§ÙÛ ",
    readAndAccept: " Ø±Ø§ Ø®ÙØ§ÙØ¯Ù Ø§Ù Ù ÙØ¨ÙÙ Ø¯Ø§Ø±Ù.",
    remainingTime: "ÙØ±ØµØª Ø¯Ø§Ø±ÛØ¯",
    productRemovedFromBasket: "Ú©Ø§ÙØ§ Ø¨Ù Ø¯ÙÛÙ Ø¹Ø¯Ù ÙÙØ¬ÙØ¯Û Ø§Ø² Ø³Ø¨Ø¯ Ø®Ø±ÛØ¯ Ø­Ø°Ù Ú¯Ø±Ø¯ÛØ¯",
    productCountChangeFrom: " ØªØ¹Ø¯Ø§Ø¯ Ø§ÙØªØ®Ø§Ø¨Û Ø§ÛÙ Ú©Ø§ÙØ§ Ø§Ø² ",
    productPriceChangeFrom: " ÙÛÙØª Ø§ÛÙ Ú©Ø§ÙØ§ Ø§Ø² ",
    changed: " ØªØºÛÛØ± ÛØ§ÙØª ",
    fromTime: "Ø§Ø² Ø³Ø§Ø¹Øª",
    initPrice: "Ø§Ø¹ØªØ¨Ø§Ø± Ø§ÙÙÛÙ",
    remainingPrice: "Ø¨Ø§ÙÛÙØ§ÙØ¯Ù Ø§Ø¹ØªØ¨Ø§Ø±",
    to: "ØªØ§",
    number: "ÙÙÙ",
    toBe: " Ø¨Ù ",
    day: "Ø±ÙØ²",
    month: "ÙØ§Ù",
    year: "Ø³Ø§Ù",
    time: "Ø³Ø§Ø¹Øª",
    yes: "Ø¨ÙÙ",
    no: "Ø®ÛØ±",
    downloadApp: "Ø¯Ø±ÛØ§ÙØª Ø§Ù¾ÙÛÚ©ÛØ´Ù",
    usefullInApp: "Ú©Ø§Ø±Ø§ÛÛ Ø¨ÙØªØ± Ø¯Ø± Ø§Ù¾ÙÛÚ©ÛØ´Ù",
    allOrder: "ÙÙÙ Ø³ÙØ§Ø±Ø´Ø§Øª",
    confirmWaitingOrder: "Ø³ÙØ§Ø±Ø´Ø§Øª Ø¯Ø± Ø§ÙØªØ¸Ø§Ø± ØªØ§ÛÛØ¯",
    confirmOrder: "Ø³ÙØ§Ø±Ø´Ø§Øª ØªØ§ÛÛØ¯ Ø´Ø¯Ù",
    sendingOrder: "Ø³ÙØ§Ø±Ø´Ø§Øª Ø¯Ø± Ø­Ø§Ù Ø§Ø±Ø³Ø§Ù",
    watingForPaymentInfo: "Ø¯Ø±Ø­Ø§Ù Ø¯Ø±ÛØ§ÙØª Ø§Ø·ÙØ§Ø¹Ø§Øª Ù¾Ø±Ø¯Ø§Ø®ØªØ ÙØ·ÙØ§ ÙÙØªØ¸Ø± Ø¨ÙØ§ÙÛØ¯...",
    watingForRegisterPaymentInfo: "Ø¯Ø±Ø­Ø§Ù ÙÙØ§ÛÛ Ø³Ø§Ø²Û Ø³ÙØ§Ø±Ø´Ø ÙØ·ÙØ§ ÙÙØªØ¸Ø± Ø¨ÙØ§ÙÛØ¯...",
    deliveredOrder: "Ø³ÙØ§Ø±Ø´Ø§Øª ØªÚ©ÙÛÙ Ø´Ø¯Ù",
    canceledOrder: "Ø³ÙØ§Ø±Ø´Ø§Øª Ø¨Ø§Ø·Ù Ø´Ø¯Ù",
    hour: "Ø³Ø§Ø¹Øª",
    minute: "Ø¯ÙÛÙÙ",
    gateway: "Ø¯Ø±Ú¯Ø§Ù",
    secend: "Ø«Ø§ÙÛÙ",
    guaranteeProduct: "Ø¶ÙØ§ÙØª Ø§ØµÙ Ø¨ÙØ¯Ù Ú©Ø§ÙØ§",
    paymentType: "Ø±ÙØ´ Ù¾Ø±Ø¯Ø§Ø®Øª",
    transactionHistory: "ØªØ§Ø±ÛØ®ÚÙ ØªØ±Ø§Ú©ÙØ´ ÙØ§",
    payInPlace: "Ù¾Ø±Ø¯Ø§Ø®Øª Ø¯Ø± ÙØ­Ù",
    deliverInPlace: "Ø§Ø±Ø³Ø§Ù Ø¨Ù ÙÙÙØ¹",
    deliverTakeName: " ÙØ§Ù ØªØ­ÙÛÙ Ú¯ÛØ±ÙØ¯Ù ",
    deliverDate: "ØªØ§Ø±ÛØ® Ø¯Ø±ÛØ§ÙØª Ø³ÙØ§Ø±Ø´",
    deliverDate_1: "ØªØ§Ø±ÛØ® Ø¯Ø±ÛØ§ÙØª",
    RegistrationDate: "ØªØ§Ø±ÛØ® Ø«Ø¨Øª",
    paymentDate: "ØªØ§Ø±ÛØ® Ù Ø³Ø§Ø¹Øª",
    paymentDeliverName: "ÙØ§Ù Ù¾Ø°ÛØ±ÙØ¯Ù",
    acceptorName: "ÙØ§Ù Ù¾Ø°ÛØ±ÙØ¯Ù",
    paymentCode: "Ú©Ø¯ Ù¾ÛÚ¯ÛØ±Û",
    successPayment: "Ù¾Ø±Ø¯Ø§Ø®Øª Ø´ÙØ§ Ø¨Ø§ ÙÙÙÙÛØª Ø§ÙØ¬Ø§Ù Ø´Ø¯",
    errorPayment_1: "Ù¾Ø±Ø¯Ø§Ø®Øª Ø´ÙØ§ Ø¨Ø§ ÙÙÙÙÛØª Ø§ÙØ¬Ø§Ù ÙØ´Ø¯",
    successOrderRegister: "Ø³ÙØ§Ø±Ø´ Ø´ÙØ§ Ø¨Ø§ ÙÙÙÙÛØª Ø«Ø¨Øª Ø´Ø¯",
    orderSendAt: "Ø³ÙØ§Ø±Ø´ Ø´ÙØ§ Ø¯Ø± ØªØ§Ø±ÛØ® Ù Ø³Ø§Ø¹Øª Ø§ÙØªØ®Ø§Ø¨ Ø´Ø¯Ù Ø¨Ù Ø¢Ø¯Ø±Ø³ ÙØ´Ø®Øµ Ø´Ø¯Ù Ø§Ø±Ø³Ø§Ù ÙÛ Ú¯Ø±Ø¯Ø¯",
    deliverTakePhone: " ØªÙÙÙ ØªØ­ÙÛÙ Ú¯ÛØ±ÙØ¯Ù ",
    fullAddress: " Ø¢Ø¯Ø±Ø³ Ø¯ÙÛÙ ",
    enterFullAddress: " Ø¢Ø¯Ø±Ø³ Ú©Ø§ÙÙ Ø®ÙØ¯ Ø±Ø§ ÙØ§Ø±Ø¯ ÙÙØ§ÛÛØ¯ ",
    titleAddress: "Ø¹ÙÙØ§Ù Ø¢Ø¯Ø±Ø³",
    finishOrder: "ØªÚ©ÙÛÙ Ø³ÙØ§Ø±Ø´",
    driverStatusChanged: "ØªØºÛÛØ± ÙØ¶Ø¹ÛØª Ø±Ø§ÙÙØ¯Ù",
    driverStatusChangedMessage: "ÙØ´ØªØ±Û Ú¯Ø±Ø§ÙÛ Ø§ÙÚ©Ø§Ù ÙØ´Ø§ÙØ¯Ù ÙØ³ÛØ± Ø­Ø±Ú©Øª ÙÙØ²Ø¹ ÙØºÙ Ú¯Ø±Ø¯ÛØ¯",
    finishOrderMessage: "ÙØ´ØªØ±Û Ú¯Ø±Ø§ÙÛ Ø¨Ø§ ØªØ´Ú©Ø± Ø§Ø² Ø®Ø±ÛØ¯ Ø´ÙØ§",
    deliverAddress: "Ø¢Ø¯Ø±Ø³ ØªØ­ÙÛÙ",
    deliverTakeAddress: "Ø¢Ø¯Ø±Ø³ ØªØ­ÙÛÙ Ú¯ÛØ±ÙØ¯Ù",
    state: "Ø§Ø³ØªØ§Ù",
    address: "Ø¢Ø¯Ø±Ø³",
    brand: "Ø¨Ø±ÙØ¯",
    sort: "ÙØ±ØªØ¨ Ø³Ø§Ø²Û",
    filter: "ÙÛÙØªØ±",
    deleteFilters: "Ø­Ø°Ù ÙÛÙØªØ± ÙØ§",
    status: "ÙØ¶Ø¹ÛØª",
    paymentDetail: "Ø¬Ø²Ø¦ÛØ§Øª Ù¾Ø±Ø¯Ø§Ø®Øª",
    paymentDetailForFinalSubmit: "Ø¬Ø²Ø¦ÛØ§Øª Ù¾Ø±Ø¯Ø§Ø®Øª Ø¬ÙØª ØªØ§ÛÛØ¯ ÙÙØ§ÛÛ",
    orderStatus: "ÙØ¶Ø¹ÛØª Ø³ÙØ§Ø±Ø´",
    system: "(Ø³ÛØ³ØªÙÛ)",
    productCount: "ØªØ¹Ø¯Ø§Ø¯ Ú©Ø§ÙØ§",
    newest: "Ø¬Ø¯ÛØ¯ØªØ±ÛÙ",
    lowCost: "Ø§Ø±Ø²Ø§Ù ØªØ±ÛÙ",
    highCost: "Ú¯Ø±Ø§Ù ØªØ±ÛÙ",
    famous: "ÙØ­Ø¨ÙØ¨ ØªØ±ÛÙ",
    highDiscount: "Ø¨ÙØ´ØªØ±ÙÙ ØªØ®ÙÙÙØ§Øª",
    from: "Ø§Ø²",
    discount: "ØªØ®ÙÙÙ",
    enterDiscountCode: "ÙØ·ÙØ§ Ú©Ø¯ ØªØ®ÙÛÙ Ø±Ø§ ÙØ§Ø±Ø¯ Ú©ÙÛØ¯",
    discountCodeUsedBefore: "Ø§ÛÙ Ú©Ø¯ ÙØ¨ÙØ§ Ø¯Ø± Ø³Ø¨Ø¯ Ø´ÙØ§ Ø§Ø¹ÙØ§Ù Ú¯Ø±Ø¯ÛØ¯Ù Ø§Ø³Øª",
    discountCodeError: "Ø¯Ø± Ø§Ø¹ÙØ§Ù Ú©Ø¯ ØªØ®ÙÛÙ Ø®Ø·Ø§ÛÛ Ø±Ø® Ø¯Ø§Ø¯Ù Ø§Ø³Øª",
    sendVerifyCodeError: 'Ø®Ø·Ø§ Ø¯Ø± Ø§Ø±Ø³Ø§Ù Ú©Ø¯ ÙØ¹Ø§ÙØ³Ø§Ø²Û',
    youreBeforeRegister: 'Ø´ÙØ§ ÙØ¨ÙØ§ Ø«Ø¨Øª ÙØ§Ù Ú©Ø±Ø¯Ù Ø§ÛØ¯',
    youreBeforeInvited: 'Ø´ÙØ§ ÙØ¨ÙØ§ ÙØ±Ø¢ÛÙØ¯ ÙØ±ÙØ¯ Ø§Ø² Ø·Ø±ÛÙ ÙÛÙÚ© Ø¯Ø¹ÙØª Ø§Ø² Ø¯ÙØ³ØªØ§Ù Ø±Ø§ Ø§ÙØ¬Ø§Ù Ø¯Ø§Ø¯Ù Ø§ÛØ¯',
    wrongPhoneNumber: 'Ø´ÙØ§Ø±Ù ÙÙØ¨Ø§ÛÙ Ø§Ø±Ø³Ø§ÙÛ ØµØ­ÛØ­ ÙÙÛ Ø¨Ø§Ø´Ø¯',
    orderNotFound: 'Ø³ÙØ§Ø±Ø´ ÛØ§ÙØª ÙØ´Ø¯',
    orderCannotBeEdit: 'ÙØ¶Ø¹ÛØª Ø³ÙØ§Ø±Ø´ Ø¯Ø± Ø­Ø§Ù Ø§ÙØªØ¸Ø§Ø± ÙÙÛ Ø¨Ø§Ø´Ø¯ Ù Ø§ÙÚ©Ø§Ù ÙÙØ±Ø§ÙØ´ ÙØ¬ÙØ¯ ÙØ¯Ø§Ø±Ø¯',
    orderCannotBeComplete: 'ÙØ¶Ø¹ÛØª Ø³ÙØ§Ø±Ø´ Ø¯Ø± Ø§ÙÙØ¸Ø§Ø± Ù¾Ø±Ø¯Ø§Ø®Øª Ø§ÛÙØªØ±ÙØªÛ ÙÙÛ Ø¨Ø§Ø´Ø¯ Ù Ø§ÙÚ©Ø§Ù ØªÚ©ÙÛÙ  ÙØ¬ÙØ¯ ÙØ¯Ø§Ø±Ø¯',
    timeVerifyCodeError: 'Ø²ÙØ§Ù Ø§Ø±Ø³Ø§Ù Ú©Ø¯ ÙØ¹Ø§ÙØ³Ø§Ø²Û Ø²ÛØ± ÙÙØ¯ Ø«Ø§ÙÛÙ Ø§Ø³Øª',
    productDiscount: "ØªØ®ÙÙÙØ§Øª Ú©Ø§ÙØ§ÛÛ",
    specialDiscount: "ØªØ®ÙÛÙØ§Øª ÙÛÚÙ",
    excessDiscount: "ØªØ®ÙÛÙ ÙØ§Ø²Ø§Ø¯",
    transportationCost: "ÙØ²ÛÙÙ Ø­ÙÙ",
    netTotal: "ÙØ§Ø¨Ù Ù¾Ø±Ø¯Ø§Ø®Øª",
    priceNetTotal: "ÙØ¨ÙØº ÙØ§Ø¨Ù Ù¾Ø±Ø¯Ø§Ø®Øª",
    onlyExistProduct: "ÙÙØ· Ú©Ø§ÙØ§ÙØ§Û ÙÙØ¬ÙØ¯",
    onlyDiscountProduct: "ÙØ­ØµÙÙØ§Øª ØªØ®ÙÛÙ Ø¯Ø§Ø±",
    exist: "ÙÙØ¬ÙØ¯",
    notExist: "ÙØ§ÙÙØ¬ÙØ¯",
    description: "ØªÙØ¶ÛØ­Ø§Øª",
    specification: "ÙØ´Ø®ØµØ§Øª",
    productDescription: "ØªÙØ¶ÛØ­Ø§Øª Ú©Ø§ÙØ§",
    productDetail: "ÙØ´Ø®ØµØ§Øª Ú©Ø§ÙØ§",
    detail: "Ø¬Ø²Ø¦ÛØ§Øª",
    neighbourhood: "ÙØ­ÙÙ",
    responseCodeIsNot200: "Ø®Ø·Ø§ÛÛ Ø±Ø® Ø¯Ø§Ø¯Ù Ø§Ø³Øª",
    articleNotFound: "ÙÙØ§ÙÙ ÙÙØ±Ø¯ ÙØ¸Ø± ÛØ§ÙØª ÙØ´Ø¯",
    successCancelOrder: "Ø³ÙØ§Ø±Ø´ Ø´ÙØ§ Ø¨Ø§ ÙÙÙÙÛØª Ø¨Ø§Ø·Ù Ø´Ø¯",
    sendMessageError: "Ø¯Ø± Ø§Ø±Ø³Ø§Ù Ù¾ÛØ§Ù Ø®Ø·Ø§ÛÛ Ø±Ø® Ø¯Ø§Ø¯Ù Ø§Ø³Øª",
    fillTitleOrDescription: "ÙØ·ÙØ§ Ø§Ø·ÙØ§Ø¹Ø§Øª ÙÙØ±Ø¯ ÙÛØ§Ø² Ø±Ø§ ÙØ§Ø±Ø¯ Ú©ÙÛØ¯",
    verifyNotSuccess: "ÙÙØ¨Ø§ÛÙ ÛØ§ Ú©Ø¯ ÙØ¹Ø§ÙØ³Ø§Ø²Û ÛØ§ Ú©Ø¯ ÙØ¹Ø±Ù Ø§Ø±Ø³Ø§ÙÛ ØµØ­ÛØ­ ÙÙÛ Ø¨Ø§Ø´Ø¯",
    resendError: 'ÙØªØ§Ø³ÙØ§ÙÙ Ø¯Ø± Ø§Ø±Ø³Ø§Ù ÙØ¬Ø¯Ø¯ Ú©Ø¯ ÙØ¹Ø§ÙØ³Ø§Ø²Û Ø®Ø·Ø§ÛÛ Ø±Ø® Ø¯Ø§Ø¯Ù Ø§Ø³Øª',
    deleteAddressError: 'ÙØªØ§Ø³ÙØ§ÙÙ Ø¯Ø± Ø­Ø°Ù Ø¢Ø¯Ø±Ø³ Ø®Ø·Ø§ÛÛ Ø±Ø® Ø¯Ø§Ø¯Ù Ø§Ø³Øª',
    setDefaultAddressError: 'ÙØªØ§Ø³ÙØ§ÙÙ Ø¯Ø± ØªØºÛÛØ± Ø¢Ø¯Ø±Ø³ Ù¾ÛØ´ ÙØ±Ø¶ Ø®Ø·Ø§ÛÛ Ø±Ø® Ø¯Ø§Ø¯Ù Ø§Ø³Øª',
    editProfileSuccess: "Ø§Ø·ÙØ§Ø¹Ø§Øª Ú©Ø§Ø±Ø¨Ø±Û Ø´ÙØ§ Ø¨Ø§ ÙÙÙÙÛØª ØªØºÛÛØ± ÛØ§ÙØª",
    sendMessageSuccess: "Ù¾ÛØ§Ù Ø´ÙØ§ Ø¨Ø§ ÙÙÙÙÛØª Ø§Ø±Ø³Ø§Ù Ø´Ø¯",
    deleteAddressSuccess: "Ø­Ø°Ù Ø¢Ø¯Ø±Ø³ Ø¨Ø§ ÙÙÙÙÛØª Ø§ÙØ¬Ø§Ù Ø´Ø¯",
    deleteNotificationSuccess: "Ø­Ø°Ù Ø§Ø¹ÙØ§Ù Ø¨Ø§ ÙÙÙÙÛØª Ø§ÙØ¬Ø§Ù Ø´Ø¯",
    addAddressSuccess: "Ø§ÙØ²ÙØ¯Ù Ø¢Ø¯Ø±Ø³ Ø¨Ø§ ÙÙÙÙÛØª Ø§ÙØ¬Ø§Ù Ø´Ø¯",
    editAddressSuccess: "ÙÛØ±Ø§ÛØ´ Ø¢Ø¯Ø±Ø³ Ø¨Ø§ ÙÙÙÙÛØª Ø§ÙØ¬Ø§Ù Ø´Ø¯",
    rateOrderSuccess: "Ø§ÙØªÛØ§Ø²Ø¯ÙÛ Ø¨Ù Ø³ÙØ§Ø±Ø´ Ø¨Ø§ ÙÙÙÙÛØª Ø§ÙØ¬Ø§Ù Ø´Ø¯",
    setDefaultAddressSuccess: "ØªØºÛÛØ± Ø¢Ø¯Ø±Ø³ Ù¾ÛØ´ ÙØ±Ø¶ Ø¨Ø§ ÙÙÙÙÛØª Ø§ÙØ¬Ø§Ù Ø´Ø¯",
    emailError: 'ÙØ±ÙØª Ø§ÛÙÛÙ Ø§Ø±Ø³Ø§ÙÛ ØµØ­ÛØ­ ÙÙÛ Ø¨Ø§Ø´Ø¯',
    emailDupliate: 'Ø§ÛÙÛÙ ØªÚ©Ø±Ø§Ø±Û Ø§Ø³Øª',
    nationalIdError: 'Ú©Ø¯ ÙÙÛ Ø§Ø±Ø³Ø§ÙÛ ØµØ­ÛØ­ ÙÙÛ Ø¨Ø§Ø´Ø¯',
    birthdateError: 'ØªØ§Ø±ÛØ® ØªÙÙØ¯ Ø§Ø´ØªØ¨Ø§Ù Ø§Ø³Øª',
    pleaseEnterVerifyCode: "ÙØ·ÙØ§ Ú©Ø¯ ÙØ¹Ø§ÙØ³Ø§Ø²Û Ø±Ø§ ÙØ§Ø±Ø¯ Ú©ÙÛØ¯",
    pleaseWait: "ÙØ·ÙØ§ ÙÙØªØ¸Ø± Ø¨ÙØ§ÙÛØ¯",
    pleaseCheckAggrement: "ÙØ·ÙØ§ ÙÙØ§ÙÛÙ Ù Ø´Ø±Ø§ÛØ· Ø±Ø§ ÙØ·Ø§ÙØ¹Ù Ù ØªØ§ÛÛØ¯ ÙÙØ§ÛÛØ¯",
    productIsLimit: "ÙØ­Ø¯ÙØ¯ÛØª ÙÙØ¬ÙØ¯Û Ú©Ø§ÙØ§ Ø¯Ø± Ø§ÙØ¨Ø§Ø±",
    enterTelephone: "Ø´ÙØ§Ø±Ù ÙÙØ¨Ø§ÛÙ Ø®ÙØ¯ Ø±Ø§ ÙØ§Ø±Ø¯ Ú©ÙÛØ¯",
    suppurtNumber: "66055000 021",
    rateOrderText_2: ' Ø´ÙØ§Ø Ø¬ÙØª Ø¨ÙØ¨ÙØ¯ Ú©ÛÙÛØª Ø§Ø±Ø§Ø¦Ù Ø®Ø¯ÙØ§Øª ØµØ±ÙÙ ÙØ§Ø±Ú©Øª ÙØ·ÙØ§ ÛÚ©Û Ø§Ø² ØµÙØ±ØªÚ© ÙØ§Û Ø²ÛØ± Ø±Ø§ Ø§ÙØªØ®Ø§Ø¨ Ú©ÙÛØ¯ Ù Ø¯Ø±ØµÙØ±Øª Ø¯Ø§Ø´ØªÙ ØªÙØ¶ÛØ­Ø§Øª Ø§Ø¶Ø§ÙÛØ Ø¢Ù Ø±Ø§ Ø¯Ø± Ú©Ø§Ø¯Ø± ÙØ±Ø¨ÙØ·Ù ÙØ§Ø±Ø¯ Ú©ÙÛØ¯ ',
    rateOrderText_1: ' Ú©Ø§Ø±Ø¨Ø± Ú¯Ø±Ø§ÙÛ Ø¨Ø§ ØªØ´Ú©Ø± Ø§Ø² Ø³ÙØ§Ø±Ø´ ',
    you: '  ',
    environmentSupporter: 'Ø­Ø§ÙÛ ÙØ­ÛØ· Ø²ÛØ³Øª',
    iAmEnvironmentSupporter: 'ÙÛØ§Ø² Ø¨Ù ÙØ§Ú©ØªÙØ± ÙØ¯Ø§Ø±Ù',
    curentValueWallet: 'ÙÙØ¬ÙØ¯Û ',
    useWallet: 'Ù¾Ø±Ø¯Ø§Ø®Øª Ø§Ø² Ø·Ø±ÛÙ Ú©ÛÙ Ù¾ÙÙ',
    wallet: 'Ú©ÛÙ Ù¾ÙÙ',
    inventory:'ÙÙØ¬ÙØ¯Û',
    descriptionEnvironmentSupporter: 'ÙØ´ØªØ±Û Ú¯Ø±Ø§ÙÛØ Ø¨Ø§ Ø¹ÙØ§ÙØª Ø²Ø¯Ù Ø§ÛÙ Ú¯Ø²ÛÙÙ ÙØ§Ú©ØªÙØ± ÚØ§Ù¾Û Ø¨Ø±Ø§Û Ø´ÙØ§ ØµØ§Ø¯Ø± ÙÙÛ Ø´ÙØ¯ Ù Ø¯Ø± ÙØµØ±Ù Ú©Ø§ØºØ° ØµØ±ÙÙ Ø¬ÙÛÛ Ø®ÙØ§ÙØ¯ Ø´Ø¯',
    howToConnectWithUsMessage1: 'ÙØ¸Ø±Ø§Øª Ù Ù¾ÛØ´ÙÙØ§Ø¯Ø§Øª Ø®ÙØ¯ Ø±Ø§ Ø§Ø² Ø·Ø±ÛÙ Ø´ÙØ§Ø±Ù ØªÙÙÙ',
    howToConnectWithUsMessage2: 'Ù Ù¾Ø³Øª Ø§ÙÚ©ØªØ±ÙÙÛÚ© info@sarfemarket.ir Ø¨Ø§ ÙØ§ Ø¯Ø±ÙÛØ§Ù Ø¨Ú¯Ø°Ø§Ø±ÛØ¯',
    sarfeDescription: 'Ø¯Ø± ÙØ±ÙØ´Ú¯Ø§Ù Ø§ÛÙØªØ±ÙØªÛ ØµØ±ÙÙ ÙØ§Ø±Ú©Øª ØªÙØ§Ø´ Ø¯Ø§Ø±ÛÙ Ø¨Ø§ Ø´Ø¹Ø§Ø± Ø³Ø±ÛØ¹Ø Ø¢Ø³Ø§ÙØ ÙØ·ÙØ¦Ù Ø¨Ø§ ØµØ±ÙÙ Ø¯Ø± Ú©ÙØªØ§Ù ØªØ±ÛÙ Ø²ÙØ§Ù ÙÙÚ©ÙØ Ø¨Ø§ Ø§ÙÚ©Ø§Ù Ø§ÙØªØ®Ø§Ø¨ Ø³Ø§Ø¯Ù Ù Ø¢Ø³Ø§Ù ÙØ­ØµÙÙØ§Øª Ø¯Ø± Ø§Ù¾ÙÛÚ©ÛØ´Ù Ù ÛØ§ ÙØ¨ Ø³Ø§ÛØª Ù Ø¨Ø§ Ø§Ø·ÙÛÙØ§Ù Ø§Ø² Ú©ÛÙÛØª ÙÙØ§Ø³Ø¨ Ú©Ø§ÙØ§Ø Ø®Ø±ÛØ¯Û Ø¨Ø§ ÙÛÙØª ÙÙØ§Ø³Ø¨ Ù Ø¨Ø§ ØµØ±ÙÙ Ø±Ø§ Ø¨Ø±Ø§Û Ø´ÙØ§ Ø®Ø±ÛØ¯Ø§Ø± ÙØ­ØªØ±Ù Ø¨Ù Ø§Ø±ÙØºØ§Ù Ø¨ÛØ§ÙØ±ÛÙ',
    sarfeCopyright: 'Ú©ÙÛÙ Ø­ÙÙÙ Ø§ÛÙ ÙØ¨Ø³Ø§ÛØª ÙØªØ¹ÙÙ Ø¨Ù Ø´Ø±Ú©Øª Ø¨Ù\u200cÙ¾Ø®Ø´ ÙÛ Ø¨Ø§Ø´Ø¯',
    aggrementText: "Ú©ÙÛÙ Ø§ØµÙÙ Ù Ø±ÙÛÙ ÙØ§Û ØµØ±ÙÙ ÙØ§Ø±Ú©Øª ÙÙØ·Ø¨Ù Ø¨Ø§ ÙÙØ§ÙÛÙ Ø¬ÙÙÙØ±Û Ø§Ø³ÙØ§ÙÛ Ø§ÛØ±Ø§ÙØ ÙØ§ÙÙÙ ØªØ¬Ø§Ø±Øª Ø§ÙÚ©ØªØ±ÙÙÛÚ© Ù ÙØ§ÙÙÙ Ø­ÙØ§ÛØª Ø§Ø² Ø­ÙÙÙ ÙØµØ±Ù Ú©ÙÙØ¯Ù Ø§Ø³Øª.\n" +
        "ÙØ±ÙØ¯ Ú©Ø§Ø±Ø¨Ø±Ø§Ù Ø¨Ù ØµØ±ÙÙ ÙØ§Ø±Ú©Øª Ø¨Ù ÙØ¹ÙØ§Û Ø¢Ú¯Ø§Ù Ø¨ÙØ¯Ù Ù Ù¾Ø°ÛØ±ÙØªÙ Ø´Ø±Ø§ÛØ· Ù ÙÙØ§ÙÛÙ ØµØ±ÙÙ ÙØ§Ø±Ú©Øª Ø§Ø³Øª. Ø¯Ø± ØµÙØ±ØªÛ Ú©Ù Ø¯Ø± ÙÙØ§ÙÛÙ ÙÙØ¯Ø±Ø¬ Ù Ø±ÙÛÙ ÙØ§ ØªØºÛÛØ±Û Ø§ÛØ¬Ø§Ø¯ Ø´ÙØ¯ Ø¯Ø± ÙÙÛÙ ØµÙØ­Ù ÙÙØªØ´Ø± Ù Ø¨Ø±ÙØ²Ø±Ø³Ø§ÙÛ ÙÛ Ø´ÙØ¯ Ù Ø´ÙØ§ ØªÙØ§ÙÙ ÙÛ Ú©ÙÛØ¯ Ú©Ù Ø§Ø³ØªÙØ§Ø¯Ù ÙØ³ØªÙØ± Ø´ÙØ§ Ø§Ø² ØµØ±ÙÙ ÙØ§Ø±Ú©ØªØ Ø¨Ù ÙØ¹ÙÛ Ù¾Ø°ÛØ±Ø´ ØªØºÛÛØ±Ø§Øª ÙÛ Ø¨Ø§Ø´Ø¯.\n" +
        "Ø¨Ø±Ø§Û Ø§Ø³ØªÙØ§Ø¯Ù Ø§Ø² ØµØ±ÙÙ ÙØ§Ø±Ú©Øª ÙØ§Ø²Ù Ø§Ø³Øª Ú©Ù ÙØ± Ú©Ø§Ø±Ø¨Ø± ÛÚ© Ø­Ø³Ø§Ø¨ Ú©Ø§Ø±Ø¨Ø±Û Ø¯Ø± ØµØ±ÙÙ ÙØ§Ø±Ú©Øª Ø¨Ø³Ø§Ø²Ø¯Ø Ø¨Ø±Ø§Û Ø§Ø³ØªÙØ§Ø¯Ù Ø§Ø² ØµØ±ÙÙ ÙØ§Ø±Ú©Øª Ú©Ø§Ø±Ø¨Ø± Ø¨Ø§ÛØ¯ ÙØ§Ù Ù ÙØ§Ù Ø®Ø§ÙÙØ§Ø¯Ú¯Û Ù Ø´ÙØ§Ø±Ù ÙÙØ±Ø§Ù Ø®ÙØ¯ Ø±Ø§ ÙØ§Ø±Ø¯ Ú©ÙØ¯Ø ÙØ³Ø¦ÙÙÛØª ÙØ§Ø±Ø¯ Ú©Ø±Ø¯Ù Ø§Ø·ÙØ§Ø¹Ø§Øª Ø§Ø´ØªØ¨Ø§Ù Ù ØºÛØ± ÙØ§ÙØ¹Û Ø§Ø² ÙØ¨ÛÙ ÙØ§Ù Ù ÙØ§Ù Ø®Ø§ÙÙØ§Ø¯Ú¯ÛØ Ø´ÙØ§Ø±Ù ØªÙØ§Ø³ Ù Ø¢Ø¯Ø±Ø³ (Ø¯Ø± ÙÙÚ¯Ø§Ù Ø«Ø¨Øª Ø³ÙØ§Ø±Ø´) Ø¨Ù Ø¹ÙØ¯Ù Ú©Ø§Ø±Ø¨Ø± Ø§Ø³Øª.\n" +
        "ÙØ± ÙØ±Ø¯ ØªÙÙØ§ ÙÛ ØªÙØ§ÙØ¯ ÛÚ© Ø­Ø³Ø§Ø¨ Ú©Ø§Ø±Ø¨Ø±Û Ø¯Ø± ØµØ±ÙÙ ÙØ§Ø±Ú©Øª Ø¯Ø§Ø´ØªÙ Ø¨Ø§Ø´Ø¯ Ù ÙØ³Ø¦ÙÙÛØª ÙÙÙ ÙØ¹Ø§ÙÛØª ÙØ§ÛÛ Ú©Ù Ø§Ø² Ø·Ø±ÛÙ Ø­Ø³Ø§Ø¨ Ú©Ø§Ø±Ø¨Ø±Û Ø¯Ø± ØµØ±ÙÙ ÙØ§Ø±Ú©Øª Ø§ÙØ¬Ø§Ù ÙÛ Ø´ÙØ¯ Ø¨Ù Ø¹ÙØ¯Ù Ú©Ø§Ø±Ø¨Ø± Ø§Ø³Øª.\n" +
        "ØµØ±ÙÙ ÙØ§Ø±Ú©Øª Ø¨Ù Ø­Ø±ÛÙ Ø®ØµÙØµÛ Ú©Ø§Ø±Ø¨Ø±Ø§Ù Ø®ÙØ¯ Ø§Ø­ØªØ±Ø§Ù ÙÛ Ú¯Ø°Ø§Ø±Ø¯ Ù ÙØªØ¹ÙØ¯ Ø¨Ù Ø­ÙØ§Ø¸Øª Ø§Ø² Ø§Ø·ÙØ§Ø¹Ø§Øª Ø´Ø®ØµÛ Ø§Ø³Øª Ú©Ù Ø´ÙØ§ Ø¯Ø± Ø§Ø®ØªÛØ§Ø± Ø¢Ù ÙÛ Ú¯Ø°Ø§Ø±ÛØ¯.",



    tickets:"Ø¯Ø±Ø®ÙØ§Ø³Øª Ù¾Ø´ØªÛØ¨Ø§ÙÛ",
    addTicket:"Ø«Ø¨Øª Ø¯Ø±Ø®ÙØ§Ø³Øª Ù¾Ø´ØªÛØ¨Ø§ÙÛ",
    ticketDetail:"Ø¬Ø²Ø¦ÛØ§Øª Ø¯Ø±Ø®ÙØ§Ø³Øª Ù¾Ø´ØªÛØ¨Ø§ÙÛ",
    ticketStatus:"ÙØ¶Ø¹ÛØª",
    maxCountSelectImage:"Ø­Ø¯Ø§Ú©Ø«Ø± ØªØ¹Ø¯Ø§Ø¯ Ø¹Ú©Ø³ Ø§ÙØªØ®Ø§Ø¨Û Ø¨ÛØ´ØªØ± Ø§Ø² Ø­Ø¯ ÙØ¬Ø§Ø² Ø§Ø³Øª",
    maxSizeSelectImage:"Ø­Ø¯Ø§Ú©Ø«Ø± Ø³Ø§ÛØ² Ø¹Ú©Ø³ Ø§ÙØªØ®Ø§Ø¨Û Ø¨ÛØ´ØªØ± Ø§Ø² Ø­Ø¯ ÙØ¬Ø§Ø² Ø§Ø³Øª",
    maxFileSelectSize:"Ø­Ø¬Ù ÙØ§ÛÙ Ø§ÙØªØ®Ø§Ø¨Û ØµØ­ÛØ­ ÙÙÛ Ø¨Ø§Ø´Ø¯",
    errorDescription:"ÙØªÙ Ù¾ÛØ§Ù Ø±Ø§ ÙØ§Ø±Ø¯ Ú©ÙÛØ¯",
    errorSubject:"ÙÙØ¶ÙØ¹ Ø±Ø§ Ø§ÙØªØ®Ø§Ø¨ ÙÙØ§ÛÛØ¯",
    customersScore:"Ø§ÙØªÛØ§Ø² Ù ÙØ¸Ø± ÙØ´ØªØ±ÛØ§Ù",
    score:"Ø§ÙØªÛØ§Ø²",
    setScore:"Ø§ÙØªÛØ§Ø² Ø¯ÙÛØ¯",
    suggest:"Ù¾ÛØ´ÙÙØ§Ø¯ Ø´Ø¯Ù ",
    submitComment:"Ø«Ø¨Øª Ø¯ÛØ¯Ú¯Ø§Ù",
    LeaveACommentAboutThisProduct:"Ø´ÙØ§ ÙÙ Ø¯Ø±Ø¨Ø§Ø±Ù Ø§ÛÙ Ú©Ø§ÙØ§ Ø¯ÛØ¯Ú¯Ø§Ù Ø«Ø¨Øª Ú©ÙÛØ¯",
    customerComments:"ÙØ¸Ø± ÙØ´ØªØ±ÛØ§Ù",
    productComment:"Ø¯ÛØ¯Ú¯Ø§Ù",
    imageList:"ÙÛØ³Øª ØªØµØ§ÙÛØ±",
    CommentsImageList:"ÙÛØ³Øª ØªØµØ§ÙÛØ± Ø§Ø±Ø³Ø§ÙÛ ÙØ´ØªØ±Û",
    CommentForProduct:"Ø¯Ø± ÙÙØ±Ø¯ Ú©Ø§ÙØ§Û ",
    textComment:"ÙØªÙ Ø¯ÛØ¯Ú¯Ø§Ù",
    errorScoreComment:"Ø§ÙØªÛØ§Ø² ÙÙÛ ØªÙØ§ÙØ¯ ØµÙØ± Ø¨Ø§Ø´Ø¯",
    errorTextComment:"ÙØªÙ Ø¯ÛØ¯Ú¯Ø§Ù Ø±Ø§ ÙØ§Ø±Ø¯ Ú©ÙÛØ¯",
    errorCountTextComment:"ÙØªÙ Ø¯ÛØ¯Ú¯Ø§Ù Ú©ÙØªØ§Ù ÙÛ Ø¨Ø§Ø´Ø¯",
    errorCharsetTextComment:"ÙØªÙ Ø¯ÛØ¯Ú¯Ø§Ù Ø¨Ø§ÛØ¯ ÙØ§Ø±Ø³Û Ø¨Ø§Ø´Ø¯",
    beforSetCommentPleaseLigin:'Ø¨Ø±Ø§Û Ø«Ø¨Øª Ø¯ÛØ¯Ú¯Ø§Ù ÙØ·ÙØ§ ÙØ§Ø±Ø¯ Ø­Ø³Ø§Ø¨ Ú©Ø§Ø±Ø¨Ø±Û Ø®ÙØ¯ Ø´ÙÛØ¯',
    enterComment:"Ø¯ÛØ¯Ú¯Ø§Ù Ø®ÙØ¯ Ø±Ø§ Ø´Ø±Ø­ Ø¯ÙÛØ¯",

};

export default messages